import { render } from "./AddModule.vue?vue&type=template&id=2c599867"
import script from "./AddModule.vue?vue&type=script&lang=js"
export * from "./AddModule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__